import ComplaintService from '../services/complaint-service';

export const complaint = {
  namespaced: true,
  state: { record: null, timeline: [], views: [], owners: [], businesses: [], aiHistory: [] },
  actions: {
    async getOwners({ commit }) {
      const owners = await ComplaintService.owners();
      commit('setOwners', owners);
      return owners;
    },
    async get({ commit }, reference) {
      commit('setRecord', null);
      const detail = await ComplaintService.get(reference);
      commit('setRecord', detail.complaint);
      commit('setBusinesses', detail.businesses || []);
      return detail.complaint;
    },
    async update({ commit }, { reference, changes }) {
      const record = await ComplaintService.update(reference, changes);
      commit('setRecord', record);
      return record;
    },
    async getTimeline({ commit }, { reference, scope, workflowId }) {
      const timeline = await ComplaintService.timeline(reference, scope, workflowId);
      commit('setTimeline', timeline);
      return timeline;
    },
    async getViews({ commit }, reference) {
      const views = await ComplaintService.views(reference);
      commit('setViews', views);
      return views;
    },
    recordView(_context, reference) {
      return ComplaintService.recordView(reference);
    },
    addNote(_context, { reference, note }) {
      return ComplaintService.addNote(reference, note);
    },
    async executeAction({ commit }, { reference, complaintWorkflowId, complaintActionTemplateId }) {
      const record = await ComplaintService.executeAction(
        reference,
        complaintWorkflowId,
        complaintActionTemplateId,
      );
      commit('setRecord', record);
      return record;
    },
    getActionDetail(
      _context,
      { reference, complaintWorkflowId, complaintActionNotificationScheduleId },
    ) {
      return ComplaintService.actionDetail(
        reference,
        complaintWorkflowId,
        complaintActionNotificationScheduleId,
      );
    },
    async getAIHistory({ commit }, reference) {
      const history = await ComplaintService.getAIHistory(reference);
      commit('setAIHistory', history || []);
      return history || [];
    },
    async requestAISummary({ commit }, reference) {
      const request = await ComplaintService.requestAISummary(reference);
      commit('upsertAIResult', request);
      return request;
    },
    async askAI({ commit }, { reference, prompt, complaintWorkflowIds }) {
      const request = await ComplaintService.askAI(reference, prompt, complaintWorkflowIds);
      commit('upsertAIResult', request);
      return request;
    },
    async getAIResult({ commit }, { reference, requestId }) {
      const result = await ComplaintService.getAIResult(reference, requestId);
      commit('upsertAIResult', result);
      return result;
    },
    async clearAIChat({ commit }, reference) {
      const result = await ComplaintService.clearAIChat(reference);
      commit('clearAIChat');
      return result;
    },
  },
  mutations: {
    setRecord(state, record) {
      state.record = record;
    },
    setTimeline(state, timeline) {
      state.timeline = timeline;
    },
    setViews(state, views) {
      state.views = views;
    },
    setOwners(state, owners) {
      state.owners = owners;
    },
    setBusinesses(state, businesses) {
      state.businesses = businesses;
    },
    setAIHistory(state, history) {
      state.aiHistory = history;
    },
    upsertAIResult(state, result) {
      if (!result?.requestId) return;
      const index = state.aiHistory.findIndex((item) => item.requestId === result.requestId);
      if (index === -1) state.aiHistory.unshift(result);
      else {
        const populatedResult = Object.fromEntries(
          Object.entries(result).filter(([, value]) => value !== null && value !== undefined),
        );
        state.aiHistory.splice(index, 1, { ...state.aiHistory[index], ...populatedResult });
      }
    },
    clearAIChat(state) {
      state.aiHistory = state.aiHistory.filter((item) => item.jobType?.toLowerCase() !== 'chat');
    },
  },
};
